import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Layout Components
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import ScrollToTop from './components/ScrollToTop';

// Page Components
import Home from './pages/Home';
import TradingPlatform from './pages/TradingPlatform';
import Markets from './pages/Markets';
import Portfolio from './pages/Portfolio';
import About from './pages/About';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Register from './pages/Register';
import News from './pages/News';
import Account from './pages/Account';
import CopyTrading from './pages/CopyTrading';
import BotsTrading from './pages/BotsTrading';
import LiveTrading from './pages/LiveTrading';
import P2PTrading from './pages/P2PTrading';
import Services from './pages/Services';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import RiskDisclosure from './pages/RiskDisclosure';
import RegulatoryInformation from './pages/RegulatoryInformation';

// Dashboard Redirect Component
const DashboardRedirect = () => {
  React.useEffect(() => {
    window.location.href = 'http://dashboard.intracapitals.com/';
  }, []);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to dashboard...</p>
      </div>
    </div>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-gray-50 overflow-x-hidden">
        <Header />
        <main className="min-h-screen w-full overflow-x-hidden">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/trading" element={<TradingPlatform />} />
            <Route path="/markets" element={<Markets />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<DashboardRedirect />} />
            <Route path="/register" element={<DashboardRedirect />} />
            <Route path="/news" element={<News />} />
            <Route path="/account" element={<Account />} />
            <Route path="/copy-trading" element={<CopyTrading />} />
            <Route path="/bots-trading" element={<BotsTrading />} />
            <Route path="/live-trading" element={<LiveTrading />} />
            <Route path="/p2p-trading" element={<P2PTrading />} />
            <Route path="/services" element={<Services />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/risk-disclosure" element={<RiskDisclosure />} />
            <Route path="/regulatory-information" element={<RegulatoryInformation />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </div>
    </Router>
  );
}

export default App;
